import { api } from './api.js';
import { startWebSocket } from './websocket.js';

/**
 * Google Client ID for the application.
 */
export const GOOGLE_CLIENT_ID = "154077098155-ns4l97hvlkno63g3rnjcm5mnflpikpd5.apps.googleusercontent.com";

/**
 * Processes the Google login by sending the token to the backend.
 * 
 * @param {string} idToken - The ID token returned by Google.
 * @param {function} navigate - The useNavigate hook function.
 * @param {function} setErrorMessage - State setter for error messages.
 * @param {function} setIsSubmitting - State setter for loading state.
 * @param {function} t - The translation function.
 */
export async function processGoogleLogin(idToken, navigate, setErrorMessage, setIsSubmitting, t) {
    try {
        setIsSubmitting(true);
        const response = await api.post('/auth/google', {
            token: idToken,
            language: navigator.language || 'en-US'
        });

        // Envia token para camada nativa do android (WebView) para autenticação nas requisições
        if (window.Android && typeof window.Android.setCookie === 'function') {
            window.Android.setCookie("token", response.data.token);
        }

        if (response.status === 200) {
            localStorage.setItem('contConectado', true);
            localStorage.setItem('typeUser', 'registrado');
            startWebSocket();
            navigate('/notepad');
        }
    } catch (error) {
        console.error("Google Authentication Error:", error);
        setErrorMessage(t("Error authenticating with Google."));
    } finally {
        setIsSubmitting(false);
    }
}

/**
 * Processes the Google registration by sending the token to the backend.
 * 
 * @param {string} idToken - The ID token returned by Google.
 * @param {object} callbacks - Object containing callback functions (onSuccess, onError, setIsSubmitting).
 * @param {function} t - The translation function.
 */
export async function processGoogleRegistration(idToken, { onSuccess, onError, setIsSubmitting }, t) {
    try {
        setIsSubmitting(true);
        const response = await api.post('/auth/user/register-google', {
            token: idToken
        });

        if (response.status === 200) {
            if (onSuccess) onSuccess(response.data);
        }
    } catch (error) {
        console.error("Google Registration Error:", error);
        if (onError) onError(error.response?.data?.msg || t("Error registering with Google."));
    } finally {
        setIsSubmitting(false);
    }
}

/**
 * Triggers the native Google login flow for Android.
 * 
 * @param {function} t - The translation function.
 * @param {function} setErrorMessage - State setter for error messages.
 */
export function handleNativeGoogleLogin(t, setErrorMessage) {
    if (window.Android && typeof window.Android.googleLogin === 'function') {
        window.Android.googleLogin();
    } else {
        console.warn("Native Google login method not found.");
        setErrorMessage(t("Native login not available."));
    }
}

/**
 * Sets up the global window listeners for native Google login callbacks.
 * 
 * @param {function} onSuccess - Callback for successful login.
 * @param {function} onFailure - Callback for failed login.
 * @returns {function} Cleanup function to remove the listeners.
 */
export function setupGoogleNativeCallbacks(onSuccess, onFailure) {
    window.onGoogleLoginSuccess = onSuccess;
    window.onGoogleLoginFailure = onFailure;

    return () => {
        window.onGoogleLoginSuccess = null;
        window.onGoogleLoginFailure = null;
    };
}
